import { makeStyles } from 'tss-react/mui';

import { inputBaseClasses } from '@mui/material';

export default makeStyles({ name: 'SearchInput' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 24,
        padding: '10px 16px 10px 24px',
        borderRadius: 12,
        border: '1px solid #ECECEC',
        background: '#F5F5F5'
    },
    input: {
        flex: 1,
        [`& .${inputBaseClasses.input}`]: {
            padding: 0,
            color: '#2D2D2D',
            caretColor: '#2D2D2D',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '21px',
            height: 21,
            letterSpacing: '-0.28px',
            '&::placeholder': {
                color: '#8E8E8E'
            }
        }
    },
    button: {
        padding: '4px 16px',
        borderRadius: 8,
        background: '#FFF !important',
        color: '#5F5F5F',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '1.2px',
        textTransform: 'uppercase'
    }
});
